import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DispositionInput } from '@/shared/inputs/DispositionInput.tsx';
import { AutomaticProductsFormValues } from '../schema/getAutomaticProductsFormSchema.ts';
import { derivePricingStrategy } from '../utils/derivePricingStrategy.ts';
import { useMemo } from 'react';
import { Fieldset, FieldsetColumn } from '../components/Fieldset.tsx';

export function DispositionFieldset() {
    const { t } = useTranslation();
    const { register, watch } = useFormContext<AutomaticProductsFormValues>();

    const [
        productType,
        isStandalone,
        isSalesTransportIncluded,
        isPurchaseTransportIncluded,
        transportNumber,
        loadingLocation,
        unloadingLocation,
    ] = watch([
        'productType',
        'isStandalone',
        'isSalesTransportIncluded',
        'isPurchaseTransportIncluded',
        'transportNumber',
        'loadingLocation',
        'unloadingLocation',
    ]);

    const businessCase = useMemo(
        () => ({
            productType,
            pricingStrategy: derivePricingStrategy(isSalesTransportIncluded, isPurchaseTransportIncluded),
            isStandalone,
        }),
        [isPurchaseTransportIncluded, isSalesTransportIncluded, productType, isStandalone]
    );

    return (
        <Fieldset title={t('forms.francoForm.sections.disposition')} dataTest="disposition-fieldset">
            <FieldsetColumn label={t('forms.francoForm.sections.disposition')}>
                <DispositionInput
                    {...register('disposition')}
                    businessCase={businessCase}
                    quantity={transportNumber ?? 0}
                    loadingLocationData={loadingLocation}
                    unloadingLocationData={unloadingLocation}
                />
            </FieldsetColumn>
        </Fieldset>
    );
}
